import { Drawer, DRAWER_SLOTS, TYPES } from '@/packages/ev-drawers/drawers';

export default {
  install(Vue) {
    let drawers = [];

    const addNewDrawer = (type, options = {}) => {
      const drawer = new Drawer({ ...options, type });
      drawers.push(drawer);
      return drawer.id;
    };

    Vue.prototype.$drawers = {
      portal: (options = {}) => addNewDrawer(TYPES.portal, options),
      form: (options = {}) => addNewDrawer(TYPES.form, options),
      list: () => drawers,
      remove: (id) => {
        drawers = drawers.filter((drawer) => drawer.id !== id);
      },
      resetAll: () => {
        drawers.length = 0;
      },
      types: TYPES,
      slots: DRAWER_SLOTS,
    };
  },
};
